import { render, staticRenderFns } from "./ClosedClients.vue?vue&type=template&id=124bec0f&scoped=true"
import script from "./ClosedClients.vue?vue&type=script&lang=ts"
export * from "./ClosedClients.vue?vue&type=script&lang=ts"
import style0 from "./ClosedClients.vue?vue&type=style&index=0&id=124bec0f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124bec0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124bec0f')) {
      api.createRecord('124bec0f', component.options)
    } else {
      api.reload('124bec0f', component.options)
    }
    module.hot.accept("./ClosedClients.vue?vue&type=template&id=124bec0f&scoped=true", function () {
      api.rerender('124bec0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/Clients/ClosedClients.vue"
export default component.exports